module.exports = __webpack_public_path__ + "static/media/bus-icon-map.329d9ae2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/bus-icon-map.svg
// module id = 868
// module chunks = 0